// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { LoadingWow } from '../../commons/molecules/loading';

export default function LoadingPayment(): Node {
  return (
    <Loading/>
  );
}


function Loading(): Node {
  return (
    <LoadingRoot>
      <LoadingWow />
    </LoadingRoot>
  );
}

const LoadingRoot = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-flow: column nowrap;
  align-items: center;
  height: 100vh;
  justify-content: center;
  background: #dfe3e8;
`;
